import React, { useEffect, useRef } from 'react';
/**
 * 超时hooks
 * @param fn
 * @param timeout
 * @param deps
 */
function useTimeout(fn: Function, timeout: number) {
  const endDate = new Date().getTime() + timeout;

  const timer: any = useRef();
  useEffect(() => {
    let startDate: number = new Date().getTime();

    if (startDate < endDate) {
      timer.current = setTimeout(() => {
        const nowDate = new Date().getTime();
        if (nowDate - endDate >= 0) {
          fn();
          window.clearTimeout(timer.current);
        }
      }, timeout);
    }
    return () => {
      timer && window.clearTimeout(timer.current);
    };
  }, []);
}
export default useTimeout;

// 目标时刻，现在时间加上10分钟
// const [tarDate] = useState(new Date().getTime() + )
// useEffect(() => {
//   if (timeoutFlag === false) {
//     timer = setInterval(() => {
//       const nowDate = new Date().getTime()
//       if (nowDate - tarDate >= 0) {
//         window.clearInterval(timer)
//         setTimeoutFlag(true)
//       }
//     }, 1000)
//   }
//   return () => {
//     timer && window.setInterval(timer)
//   }
// }, [timeoutFlag])
